import { Outlet } from "react-router-dom";
import { Flex, Box, useDisclosure } from "@chakra-ui/react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import RegistrarPlantaoModal from "../../features/plantoes/components/RegistrarPlantaoModal";
import { useAlertasQuery } from "../../features/alertas/hooks/useAlertasQuery";
import EmailNaoVerificadoBanner from "./EmailNaoVerificadoBanner";
import TrialBanner from "./TrialBanner";
import FeedbackButton from "../../features/feedback/components/FeedbackButton";
import TermsAcceptanceModal from "../../features/terms/components/TermsAcceptanceModal";
import PlanoBloqueadoModal from "../../features/assinatura/components/PlanoBloqueadoModal";

// Layout raiz das rotas autenticadas — substitui DashboardLayout.js. O estado do modal
// "Registrar plantão" mora aqui porque é acionado tanto pela Navbar quanto pelo
// MobileDrawer. O pb maior no main reserva espaço para o botão flutuante de feedback não
// cobrir o fim do conteúdo (última linha de tabela, botões de rodapé).
export default function AppShell() {
  const registrarPlantao = useDisclosure();
  const { data: alertas = [], isLoading: alertasLoading, isError: alertasError } = useAlertasQuery();

  return (
    <Flex minH="100vh" bg="app-page">
      <Sidebar />
      <Box flex={1} minW={0}>
        <Navbar
          onRegistrarPlantao={registrarPlantao.onOpen}
          alertas={alertas}
          alertasLoading={alertasLoading}
          alertasError={alertasError}
        />
        <EmailNaoVerificadoBanner />
        <TrialBanner />
        <Box as="main" p={{ base: 4, md: 6 }} pb={{ base: 20, md: 24 }} maxW="1400px" mx="auto">
          <Outlet context={{ registrarPlantaoDisclosure: registrarPlantao }} />
        </Box>
      </Box>
      <RegistrarPlantaoModal isOpen={registrarPlantao.isOpen} onClose={registrarPlantao.onClose} />
      <FeedbackButton />
      <TermsAcceptanceModal />
      <PlanoBloqueadoModal />
    </Flex>
  );
}
